<template>
  <div class="modal-warning modal-content">
      <button @click="$emit('close')" type="button" data-dismiss="modal" aria-label="Close" class="close"
              style="width: 30px; height: 30px; border-radius: 30px; font-size: 30px; background: gray;"><span
              aria-hidden="true">×</span></button>
      <!-- <h2 class="modal-title title-coupons lg-cond text-center pt-10 pb-10">
          {{ title }}
      </h2> -->
     <div class="modal-title title-coupons lg-cond text-center pt-20 pb-10">
      </div>
      <div class="free-menu-description section-content--free-menu t13 text-black text-center pt-10 pb-10">
          {{ message }}
      </div>
      <button type="button" @click="$emit('close')"
              class="btn btn-success button-coupon-text t16 fw600">{{$t('proceed_to_order')}}
      </button>
  </div>
</template>

<script>
export default {
  props: {
    outlet: {
      type: Object
    },
    title: {
      type: String
    },
    message: {
      type: String
    },
    closeCallBack: {
      type: Function
    }
  },
  destroyed () {
    this.closeCallBack(this.outlet)
  }
}
</script>

<style scoped>
  .close {
      margin-top: 0px;
  }

  button {
      margin: auto;
      width: 100%;
      margin-top: 20px;
  }

  .modal-notify {
      max-width: 400px;
      margin: auto;
      background: white;
      padding: 15px;
  }

  .alert-danger2 {
      color: #a94442;
      font-weight: bold;
  }

  .free-menu-description {
      cursor: pointer;
  }

  .v--modal-box {
      height: auto !important;
      top: 50px !important;
  }

  .modal-coupon .v--modal {
      min-width: 0px !important;
  }

  .v--modal .modal-warning {
    padding: 16px;
    max-width: 500px;
    margin: auto;
    margin-top: 60px;
  }
</style>



// WEBPACK FOOTER //
// src/components/popup/ModalWarning.vue